import styled from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';
import Popover from './Popover';

export const StyledPopover = styled(Popover)`
  .ant-popover-inner {
    border-radius: 8px;
    padding: 16px 20px;
    box-shadow:
      0px 8px 22px -6px rgba(24, 39, 75, 0.06),
      0px 14px 64px -4px rgba(24, 39, 75, 0.06);
    line-height: 24px;

    &-content {
      color: ${colors.gray900};
    }
  }

  .ant-popover-title {
    border: none;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 4px;
    min-height: 24px;
    color: ${colors.gray900};
  }

  .ant-popover-arrow {
    width: 12px;
    height: 12px;

    &-content {
      box-shadow: none;
      width: 8.49px;
      height: 8.49px;
      transform: translate(0, 0) rotate(45deg);
    }
  }

  &.ant-popover-placement-right,
  &.ant-popover-placement-rightTop,
  &.ant-popover-placement-rightBottom {
    padding-left: 6px;

    .ant-popover-arrow-content {
      left: -2px;
    }
  }

  &.ant-popover-placement-top,
  &.ant-popover-placement-topLeft,
  &.ant-popover-placement-topRight {
    padding-bottom: 6px;
    padding-top: 4px;

    .ant-popover-arrow {
      bottom: 0;
    }
  }

  &.ant-popover-placement-bottom,
  &.ant-popover-placement-bottomLeft,
  &.ant-popover-placement-bottomRight {
    padding-top: 6px;

    .ant-popover-arrow {
      top: 0;
    }
  }

  &.ant-popover-placement-left,
  &.ant-popover-placement-leftTop,
  &.ant-popover-placement-leftBottom {
    .ant-popover-arrow-content {
      right: 4px;
      left: auto;
    }
  }

  .ant-popover-title,
  .ant-popover-inner-content {
    padding: 0;
  }
`;
